import { AuthenticatedLayout } from "features/common/components/AuthendicatedLayout";
import { ReportPreview } from "features/report/components/ReportPreview";

export const ExternalStatistics = () => {
  return (
    <AuthenticatedLayout>
      <ReportPreview action="STATISTICS" />
    </AuthenticatedLayout>
  );
};
